import { render, staticRenderFns } from "./definir-valor.vue?vue&type=template&id=2189f4a0&scoped=true&"
import script from "./definir-valor.vue?vue&type=script&lang=js&"
export * from "./definir-valor.vue?vue&type=script&lang=js&"
import style0 from "./definir-valor.vue?vue&type=style&index=0&id=2189f4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189f4a0",
  null
  
)

export default component.exports